import React, { FC, Fragment } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { useNavigate } from 'react-router-dom';
import RequestStatusTag from 'components/base/request-status-tag';
import useBrandChefsContext from 'contexts/brand-chefs.context/context';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import { PrepRequestType } from 'models/prep-request.model';
import { formatCurrency, formatRequestDate } from 'utils/functions';

type Props = {
  request: PrepRequestType;
};

const BrandChefsRequestCard: FC<Props> = ({ request }) => {
  const orderCode = request?.code;
  const { setActiveRequest, setStep } = useBrandChefsContext();
  const router = useNavigate();

  const viewRequest = () => {
    setActiveRequest(request);
    setStep(1);
    const requestStatus = request.status;
    const brandRoutes: Partial<Record<ENUM_REQUEST_STATUS, string>> = {
      [ENUM_REQUEST_STATUS.SENT]: `receive-items/${request.id}`,
      [ENUM_REQUEST_STATUS.RECEIVED]: `receive-items/${request.id}`,
      [ENUM_REQUEST_STATUS.REVIEWED]: `complete/${request.id}`
    };
    const route = brandRoutes[requestStatus] || MAIN_STORE_ROUTE_KEYS.EDIT_REQUEST;
    router(route);
  };

  return (
    <Fragment>
      <div className='border hover:bg-gray-11 border-gray-13 rounded-lg flex flex-col py-2 w-full'>
        <div className='grow'>
          <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between px-3'>
            <h4 className='font-medium text-base cursor-pointer'>#{orderCode}</h4>
            <RequestStatusTag status={request.status} />
          </div>

          <div className='p-3 text-xs max-h-[100px] overflow-y-auto overflow-x-hidden'>
            {request?.items?.map((item, i) => (
              <div key={i} className='flex  items-center pb-1 '>
                <p>{item.ingredient.name} </p>
                <div className='bg-[#DCDBD5] inline-block mx-1 w-[5px] h-[5px] rounded-full' />
                <p className=' text-gray-5'>
                  {' '}
                  {item.quantity_requested} {item.ingredient.unit_type || 'portions'} (
                  <span>
                    {formatCurrency(
                      Number(item.quantity_requested) * Number(item.ingredient.min_vendor_price)
                    )}
                  </span>
                  )
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className='flex border-t border-[#ECEDEF] pb-2 text-xs items-center gap-2 flex-wrap justify-between mx-3 pt-2'>
          <p>Created {formatRequestDate(request.created_at)}</p>
          <Button className='text-xs' color='primary' variant='link' onClick={() => viewRequest()}>
            See all
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default BrandChefsRequestCard;
